import Button from '../../../components/button/button';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAlert } from '../../../hooks/useAlert';
import { useLogin } from '../../../hooks/useLogin';

const API_URL = process.env.REACT_APP_API_URL;

export default function DeleteAccount() {
    const navigate = useNavigate();
    const { showAlert } = useAlert();
    const { handleLogout } = useLogin();
    const handleDeactivateAccount = async () => {
        const confirmed = window.confirm(
            'Der Account wird deaktiviert. Bitte bestätige, dass du deinen Account deaktivieren willst. ' +
            'Solltest du es dir später anders überlegen, kannst du dich jederzeit bei unserem Support melden ' +
            'und deinen Account reaktivieren lassen.'
        );

        if (!confirmed) {
            return;
        }

        try {
            await axios.patch(`${API_URL}/users/deactivateMe`, {}, { withCredentials: true });
            showAlert('Account erfolgreich deaktiviert', 'success');
            setTimeout(() => {
                handleLogout();
            }, 2000);
        } catch (error) {
            const msg = error?.response?.data?.message || 'Fehler beim Deaktivieren des Accounts';
            showAlert(msg, 'error');
        }
    };
    

    return (
        <div>
            <p>
                Du kannst hier deinen Account deaktivieren. 
                Um ihn endgültig zu löschen, wende dich an unseren Support.
            </p>
            <Button buttonValue='Account deaktivieren' onClick={handleDeactivateAccount} />
        </div>
    )
}